import React, { forwardRef } from "react";
import { IArticleListingDetail } from "components/ArticleListing/ArticleListing.interface";
import ArticleOption from "../ArticleOption/ArticleOption";
import Pagination from "../Pagination/Pagination";
import styles from "./ArticleDetails.module.css";

const ArticleDetails = forwardRef<HTMLDivElement, IArticleListingDetail>(
  (props, ref) => {
    const { data, title, setTitle, pageNumber, setPageNumber, totalCount } =
      props;

    return (
      <div ref={ref} className={styles.container}>
        <p className={styles.title}>{title.name}</p>
        <div className={styles.subcontainer}>
          {data &&
            data.map((item, index) => (
              <ArticleOption
                {...item}
                key={item.url}
                firstImage={index === 0}
                setTitle={setTitle}
              />
            ))}
        </div>
        <div className={styles.pagination}>
          <Pagination
            page={pageNumber}
            totalCount={Number(totalCount)}
            onChange={setPageNumber}
          />
        </div>
      </div>
    );
  }
);

export default ArticleDetails;
